import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ikas from "../../providers/ikas";
import { CaretRightIcon } from "@phosphor-icons/react";

import * as compSettings from "./settings";
import CityAndDistrict from "../CityAndDistrict";
export default function AddressUpsert({
  id,
  extendedSettings,
  selectPage,
  setSelectPage,
  data,
  dataSetter,
}) {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  // Ayarları değişkenlere ata (default değer atama yok)
  const backgroundColor = settings.backgroundColor?.value;
  const borderRadius = settings.borderRadius?.value;
  const boxShadow = settings.boxShadow?.value;
  const padding = settings.padding?.value;
  const inputTextColor = settings.inputTextColor?.value;
  const inputTextSize = settings.inputTextSize?.value;
  const labelColor = settings.labelColor?.value;
  const labelSize = settings.labelSize?.value;
  const buttonColor = settings.buttonColor?.value;
  const buttonTextColor = settings.buttonTextColor?.value;
  const buttonRadius = settings.buttonRadius?.value;

  const location = useLocation();
  const address = location.state;

  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [title, setTitle] = useState("");
  const [phone, setPhone] = useState("");
  const [addressDetail, setAddressDetail] = useState("");
  const [addressDetail2, setAddressDetail2] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");

  const [toast, setToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [touched, setTouched] = useState({});
  const [invalid, setInvalid] = useState({});

  const handleBlur = (field) =>
    setTouched((prev) => ({ ...prev, [field]: true }));
  const handleInput = (field, value) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    setInvalid((prev) => ({ ...prev, [field]: false }));
  };
  const validateTitle = (val) => val.trim().length > 1;
  const validateName = (val) => val.trim().length > 1;
  const validateSurname = (val) => val.trim().length > 1;
  const validatePhone = (val) => val.trim().length > 5;
  const validateAddress1 = (val) => val.trim().length > 3;
  const validateCity = (val) => val?.name?.trim().length > 0;
  const validateDistrict = (val) => val?.name?.trim().length > 0;

  const handleUpsertAddress = () => {
    const newInvalid = {
      title: !validateTitle(title),
      name: !validateName(name),
      surname: !validateSurname(surname),
      phone: !validatePhone(phone),
      address1: !validateAddress1(addressDetail),
      city: !validateCity(city),
      district: !validateDistrict(district),
    };
    setInvalid(newInvalid);
    setTouched({
      title: true,
      name: true,
      surname: true,
      phone: true,
      address1: true,
      city: true,
      district: true,
    });
    if (Object.values(newInvalid).some(Boolean)) {
      setToastType("error");
      setToast("Lütfen tüm alanları doğru doldurun.");
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setTimeout(() => setToast(""), 400);
      }, 1800);
      return;
    }
    setLoading(true);
    const addressInput = {
      id: null,
      title: title,
      firstName: name,
      lastName: surname,
      phone: phone,
      addressLine1: addressDetail,
      addressLine2: addressDetail2,
      country: {
        code: "TUR",
        id: "da8c5f2a-8d37-48a8-beff-6ab3793a1861",
        iso2: "TR",
        iso3: "TUR",
        name: "Türkiye",
      },
      city: {
        id: city.id,
        name: city.name,
      },
      district: {
        id: district.id,
        name: district.name,
      },
      state: {
        code: null,
        id: "dcb9135c-4b84-4c06-9a42-f359317a9b78",
        name: "Default",
      },
    };
    let newAddresses = data.customer?.addresses.concat() || [];
    if (address?.id) {
      newAddresses = newAddresses.filter((addr) => addr.id !== address.id);
    }
    newAddresses.push(addressInput);

    const upsertPromise = ikas.saveMyCustomer({
      firstName: data.customer.firstName,
      lastName: data.customer.lastName,
      addresses: newAddresses,
    });
    upsertPromise
      .then(async (response) => {
        dataSetter(response);
        setLoading(false);
        setToastType("success");
        setToast(
          address?.id
            ? "Adres başarıyla güncellendi"
            : "Adres başarıyla eklendi"
        );
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          setTimeout(() => setToast(""), 400);
        }, 1200);

        navigate("/account/addresses");
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setToastType("error");
        setToast("Adres eklenirken bir hata oluştu.");
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          setTimeout(() => setToast(""), 400);
        }, 1800);
      });
  };

  useEffect(() => {
    if (address) {
      setTitle(address.title || "");
      setName(address.firstName || "");
      setSurname(address.lastName || "");
      setPhone(address.phone || "");
      setAddressDetail(address.addressLine1 || "");
      setAddressDetail2(address.addressLine2 || "");
      setCity(address.city || "");
      setDistrict(address.district || "");
    }
  }, [address]);

  return (
    <div
      className="relative"
      style={{ background: backgroundColor, borderRadius, boxShadow, padding }}
    >
      {toast && (
        <div
          className={`fixed  left-1/2 transform -translate-x-1/2 z-[100] w-[95vw] max-w-xl px-6 py-3 rounded-lg shadow-lg text-base font-semibold text-center transition-all duration-400
            ${
              showToast
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-4 pointer-events-none"
            }`}
          style={{
            top: data?.system?.safeArea?.top ?? 20,
            minWidth: 320,
            backgroundColor: toastType === "error" ? "#ef4444" : "#6f59ef",
            color: "#fff",
          }}
        >
          {toast}
        </div>
      )}
      {loading && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center transition-opacity duration-200">
          <span className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
        </div>
      )}
      {selectPage === "address" && (
        <div className="w-full max-w-sm min-w-[200px] flex flex-col gap-4 mx-auto pb-40">
          <div className="relative">
            <label style={{ color: labelColor, fontSize: labelSize }}>
              Adres Başlığı
            </label>
            <input
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                handleInput("title", e.target.value);
              }}
              onBlur={() => handleBlur("title")}
              type="text"
              className={`w-full pl-2 py-2 bg-transparent placeholder:text-gray-400 border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow ${
                invalid.title && touched.title
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              style={{ color: inputTextColor, fontSize: inputTextSize }}
              placeholder="Örn: Ev Adresim"
            />
          </div>
          <div className="relative">
            <label style={{ color: labelColor, fontSize: labelSize }}>Ad</label>
            <input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                handleInput("name", e.target.value);
              }}
              onBlur={() => handleBlur("name")}
              type="text"
              className={`w-full pl-2 py-2 bg-transparent placeholder:text-gray-400 border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow ${
                invalid.name && touched.name
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              style={{ color: inputTextColor, fontSize: inputTextSize }}
              placeholder="Ad"
            />
          </div>
          <div className="relative">
            <label style={{ color: labelColor, fontSize: labelSize }}>
              Soyad
            </label>
            <input
              value={surname}
              onChange={(e) => {
                setSurname(e.target.value);
                handleInput("surname", e.target.value);
              }}
              onBlur={() => handleBlur("surname")}
              type="text"
              className={`w-full pl-2 py-2 bg-transparent placeholder:text-gray-400 border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow ${
                invalid.surname && touched.surname
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              style={{ color: inputTextColor, fontSize: inputTextSize }}
              placeholder="Soyad"
            />
          </div>
          <div className="relative">
            <label style={{ color: labelColor, fontSize: labelSize }}>
              Telefon Numarası
            </label>
            <input
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
                handleInput("phone", e.target.value);
              }}
              onBlur={() => handleBlur("phone")}
              type="text"
              className={`w-full pl-2 py-2 bg-transparent placeholder:text-gray-400 border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow ${
                invalid.phone && touched.phone
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              style={{ color: inputTextColor, fontSize: inputTextSize }}
              placeholder="Telefon Numarası"
            />
          </div>
          <div className="relative">
            <label style={{ color: labelColor, fontSize: labelSize }}>
              Adres Detayı
            </label>
            <input
              value={addressDetail}
              onChange={(e) => {
                setAddressDetail(e.target.value);
                handleInput("address1", e.target.value);
              }}
              onBlur={() => handleBlur("address1")}
              type="text"
              className={`w-full pl-2 py-2 bg-transparent placeholder:text-gray-400 border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow ${
                invalid.address1 && touched.address1
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              style={{ color: inputTextColor, fontSize: inputTextSize }}
              placeholder="Adres Detayı"
            />
          </div>
          <div className="relative">
            <label style={{ color: labelColor, fontSize: labelSize }}>
              Daire, Apartman No. vs.
            </label>
            <input
              value={addressDetail2}
              onChange={(e) => {
                setAddressDetail2(e.target.value);
                handleInput("address2", e.target.value);
              }}
              type="text"
              className="w-full pl-2 py-2 bg-transparent placeholder:text-gray-400 border border-gray-300 rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow"
              style={{ color: inputTextColor, fontSize: inputTextSize }}
              placeholder="Daire, Apartman No. vs."
            />
          </div>
          <div>
            <label style={{ color: labelColor, fontSize: labelSize }}>
              Şehir
            </label>
            <div className="relative">
              <input
                value={city.name}
                onClick={() => setSelectPage("city")}
                onBlur={() => handleBlur("city")}
                type="text"
                className={`w-full pl-2 pr-10 py-2 bg-transparent placeholder:text-gray-400 border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow ${
                  invalid.city && touched.city
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                style={{ color: inputTextColor, fontSize: inputTextSize }}
                placeholder="Şehir"
                readOnly
              />
              <CaretRightIcon className="pointer-events-none absolute top-1/2 right-3 h-5 w-5 -translate-y-1/2 text-slate-600" />
            </div>
          </div>
          <div>
            <label style={{ color: labelColor, fontSize: labelSize }}>
              İlçe
            </label>
            <div className="relative">
              <input
                value={district.name}
                onClick={() => setSelectPage("district")}
                onBlur={() => handleBlur("district")}
                type="text"
                className={`w-full pl-2 pr-10 py-2 bg-transparent placeholder:text-gray-400 border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-400 hover:border-gray-400 shadow-sm focus:shadow ${
                  invalid.district && touched.district
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                style={{ color: inputTextColor, fontSize: inputTextSize }}
                placeholder="İlçe"
                readOnly
              />
              <CaretRightIcon className="pointer-events-none absolute top-1/2 right-3 h-5 w-5 -translate-y-1/2 text-slate-600" />
            </div>
          </div>
        </div>
      )}
      {selectPage === "address" && (
        <div className="w-full max-w-sm min-w-[200px] flex items-center flex-col gap-4 mx-auto px-2 fixed left-1/2 -translate-x-1/2 bottom-10 z-20">
          <button
            style={{
              background: buttonColor,
              color: buttonTextColor,
              borderRadius: buttonRadius,
              fontSize: inputTextSize,
              padding: padding,
              boxShadow,
            }}
            className="w-full text-center shadow-lg"
            onClick={handleUpsertAddress}
            disabled={loading}
          >
            {address?.id ? "Adresi Güncelle" : "Adres Ekle"}
          </button>
        </div>
      )}
      {selectPage === "city" && (
        <CityAndDistrict
          city={city}
          setCity={setCity}
          district={district}
          setDistrict={setDistrict}
          selectPage={selectPage}
          setSelectPage={setSelectPage}
        />
      )}
      {selectPage === "district" && (
        <CityAndDistrict
          city={city}
          setCity={setCity}
          district={district}
          setDistrict={setDistrict}
          selectPage={selectPage}
          setSelectPage={setSelectPage}
        />
      )}
    </div>
  );
}
